// Fire-and-forget command from a Pos.Ws that does not wait for results.
export const POS_COMMAND_HUB_METHOD = 'PosCommand';
// Command the server waits for: the handler's result goes back to the admin.
export const POS_COMMAND_REQUEST_HUB_METHOD = 'PosCommandRequest';
// Sent as cmdv in the hub URL: Pos.Ws uses PosCommandRequest only for terminals with 2 or more.
export const DEVICE_WS_COMMAND_PROTOCOL = 2;

export type PosCommandName =
  | 'syncData'
  | 'prroConfigUpdate'
  | 'ping'
  | 'getState'
  | 'navigate'
  | 'screenshot'
  | 'uploadStorage'
  | 'getStorage'
  | 'setStorage'
  | 'deleteStorage'
  | 'readStorage'
  | 'reload'
  | 'dialog'
  | 'prro'
  | 'getOverview'
  | 'getLogs';

export interface PosCommandEnvelope {
  // Command id, the same for every status the admin sees.
  correlationId: string;
  command: string;
  deviceId: string;
  payload?: unknown;
  issuedBy?: string;
  issuedAtUtc?: string;
  expiresAtUtc?: string;
  timeoutMs?: number;
}

export interface PosCommandResult {
  success: boolean;
  data?: unknown;
  error?: string;
}

// Returns the command's data (any JSON) or throws to fail it.
export type PosCommandHandler = (
  payload: any,
  envelope: PosCommandEnvelope,
) => unknown | Promise<unknown>;
